/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Valid energy sources.
 */
export enum EnergyType {
  ELECTRIC = 'electric',
  NATURAL_GAS = 'natural_gas',
  OIL = 'oil',
  PROPANE = 'propane',
  WOOD = 'wood',
  OTHER = 'other',
  TOTAL = 'total',
  BIOMASS = 'biomass',
  NONE = 'none',
}
